import {
  Box,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { FilterChip } from "./filterChip";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 12,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  content: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    flexDirection: "column",
    width: "100%",
  },
  title: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  chipsContainer: {
    display: "flex",
    justifyContent: "start",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  icon: {
    fill: theme.palette.primary.main,
  },
}));

export const ActiveFilters = observer(() => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolFiltersStore } = compToolStore;
  const classes = useStyles();

  const activeFilters = compToolFiltersStore.activeFilters;

  const clearFilterHandler = (filterName) => {
    if (compToolFiltersStore.clearFilter(filterName, true)) {
      compToolStore.applyFilters();
    }
  }

  const clearAllFiltersHandler = () => {
    compToolFiltersStore.clearFilters();
    compToolStore.setDefaultFilters();
    compToolStore.applyFilters();
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Box display="flex" justifyContent="space-between">
          <Box className={classes.title}>
            <InfoOutlinedIcon style={{ marginRight: 4 }} className={classes.icon} />
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Filtered by
            </Typography>
          </Box>
          <IconButton size="small" onClick={clearAllFiltersHandler}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        </Box>
        <Box className={classes.chipsContainer}>
          {activeFilters.map(f => (
            <FilterChip key={f.id} label={f.label} onDelete={() => clearFilterHandler(f.id)} />
          ))}
        </Box>
      </Box>
    </Box>
  );
});
